var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5164_53183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5164_53183)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.33301L4.5 6.66634C4.5 6.66634 4.5 11.9997 4.5 14.6663C4.5 25.1063 13.0853 29.981 16.5 30.6663C19.9147 29.981 28.5 25.1063 28.5 14.6663C28.5 11.9997 28.5 6.66634 28.5 6.66634L16.5 1.33301Z",
    fill: "url(#paint0_linear_5164_53183)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5164_53183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 25,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.33301L4.5 6.66634C4.5 6.66634 4.5 11.9997 4.5 14.6663C4.5 25.1063 13.0853 29.981 16.5 30.6663C19.9147 29.981 28.5 25.1063 28.5 14.6663C28.5 11.9997 28.5 6.66634 28.5 6.66634L16.5 1.33301Z",
    fill: "#F49120"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5164_53183)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 16,
    y: -5,
    width: 18,
    height: 47,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5164_53183",
    x1: 4.5,
    y1: -4.5,
    x2: 28.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA945"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5164_53183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5164_53183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 62,
    fill: "white",
    transform: "translate(4.5 -5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.272fb0ba3ff587fcfa49e1e180a66a51.svg";
export { ForwardRef as ReactComponent };